import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

import type { PickAnyFromSearchParams } from '@/ducks/pages/navigation';

import { checkAreCelebrationSearchParamsEmpty } from '@/ducks/programs/celebrations/searchParams';
import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import { backToMainPage, toPreCheckoutPage } from '@/ducks/voyageInfo/category/navigation';
import { useAppSelector } from '@/store';

import { routes } from './../../routes/routes';

enum USER_FLOWS {
  REGULAR = 'REGULAR',
  CELEBRATION = 'CELEBRATION',
}

const REDIRECT_TO_BEGINNING_FLOW: Record<USER_FLOWS, { page: string; redirect: (...args: any[]) => void }> = {
  [USER_FLOWS.CELEBRATION]: {
    page: routes.planner.preCheckOut.path,
    redirect: toPreCheckoutPage,
  },
  [USER_FLOWS.REGULAR]: {
    page: routes.planner.chooseVoyage.path,
    redirect: backToMainPage,
  },
};

export const useGetBackToFlow = (args?: PickAnyFromSearchParams) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isCelebrationsFlowActive = useAppSelector(selectCelebrationsIsFlowActive);
  const areCelebrationSearchParamsEmpty = checkAreCelebrationSearchParamsEmpty(searchParams); // on clean page loading celebration data was'nt fetched yet, but params exist
  const userFlow = isCelebrationsFlowActive || !areCelebrationSearchParamsEmpty ? 'CELEBRATION' : 'REGULAR';

  return useCallback(() => {
    if (pathname !== REDIRECT_TO_BEGINNING_FLOW[userFlow].page) {
      REDIRECT_TO_BEGINNING_FLOW[userFlow].redirect(args);
    }
  }, [pathname, userFlow, args]);
};
